module.exports = __webpack_public_path__ + "img/sticker-1-0.480f7af1.svg";